/** A date-only value (YYYY-MM-DD) as "25 Oct 2026". No time-zone shift: these are calendar days. */
export function formatDate(day: string | null | undefined): string {
  if (!day) return '';
  const d = new Date(`${day}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return day;
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeZone: 'UTC' }).format(d);
}
